import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { ExportViewProps, ExportViewRef } from "./models";
import SearchFilter, { Filters } from "../../../Common/SearchFilter/SearchFilter";
import { searchFilterToExportExcelFilter } from "../../../Common/SearchFilter/utils";
import useDidMountEffect from "../../../Common/UseDidMountEffect";
import { ApiBackend } from "../../../../providers/apibackend";
import { Event } from "../../../../model/Event";
import { Product } from "../../../../model/Product";

type SearchFilterType = {
    raceWeek?: string;
    races?: string[];
    perStartGroup?: boolean;
};

interface ISearchFilter {
    raceWeek?: string;
    races?: string[];
    perStartGroup?: boolean;
}

const EventWeekStatistics = forwardRef<ExportViewRef, ExportViewProps>((props, ref) => {
    const [searchFilter, setSearchFilter] = useState(null as ISearchFilter);
    const [events, setEvents] = useState(null as Event[]);
    const [races, setRaces] = useState(null as Product[]);

    useImperativeHandle(ref, () => ({
        isValid: () => {
            return !!searchFilter?.raceWeek;
        }
    }));

    useEffect(() => {
        const backend = new ApiBackend();
        backend.listEvents().then((res) => { setEvents(res); });
        backend.listProducts().then((res) => { setRaces(res); });
    }, []);

    useDidMountEffect(() => {
        props.onChange(searchFilterToExportExcelFilter<ISearchFilter>(searchFilter));
    }, [searchFilter]);

    const render = () => {
        const selRaces = races?.filter(x => searchFilter?.raceWeek && x.EventId == searchFilter.raceWeek && x.type == "race");
        return (
            <SearchFilter<SearchFilterType>
                id={"export-eventweekstatistics-filter"}
                filters={{
                    "raceWeek": {
                        id: "filter-raceWeek",
                        type: "GenericSelect",
                        label: "Evenemang",
                        size: 12,
                        multiple: false,
                        itemDefinition: {
                            items: events == null ? [] : events.map(x => { return { name: x.name, value: x.id } }),
                            itemValueType: "string"
                        }
                    },
                    "races": {
                        id: "filter-races",
                        type: "GenericSelect",
                        label: "Lopp (valfritt, tomt = alla lopp i evenemanget)",
                        size: 12,
                        multiple: true,
                        itemDefinition: {
                            items: selRaces == null ? [] : selRaces.map(x => { return { name: x.name + '', value: x.id } }),
                            itemValueType: "string"
                        }
                    },
                    "perStartGroup": {
                        id: "filter-perstartgroup",
                        type: "Checkbox",
                        label: "Statistik per startled",
                        size: 12,
                        defaultValue: false,
                        multiple: false
                    },
                }}
                persist={true}
                onInit={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
                onChange={(filter: Filters<SearchFilterType>) => {
                    setSearchFilter(filter as unknown as ISearchFilter);
                }}
            />
        );
    };

    return render();
});

export default EventWeekStatistics;
